import React from 'react'

import logo from "../assets/images/logo.png";
import bkg from "../assets/images/frame-bkg.svg";

function AuthLayout({children}) {
  return (
    // section start here
    <section className="w_100">
            {/* <div className="container"> */}
                
                {/* header start */}
                {/* <header>
                    <div className="logo">
                        <img src={logo} />
                    </div>
                    <div className="title">
                        <h1>SUNDANCE FILM FESTIVAL - Digital CMS</h1>
                    </div>
                    <div className="support_link">
                        <a href="mailto:sff21@sundance.org" target="_blank" >Contact Support</a>
                    </div>
                </header> */}
                {/* header end */}

                {/* Background Block start here */}
                <div className="sundance_wrapper w_100">

                    {/* For Background Images */}
                    <div className="background">
                        <img src={'https://d2wsrejhnxatgp.cloudfront.net/assest/common/CMS_Background.png'} />
                    </div>
                    {/* // For Background Images */}

                    {/* Box Design Start here */}
                    {children}
                    {/* Box Design End's here */}

                </div>
                {/* Background Block end's here */}
            {/* </div> */}
        </section>
    // section end here
  )
}

export default AuthLayout